import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  TextField,
  makeStyles,
} from "@material-ui/core";
import { customtheme } from "../../../app/theme/theme";
import { useState } from "react";
import SearchIcon from '@material-ui/icons/Search';
import { handleReturnValue } from '../../../common/functions/returnValue';
import { DialogSearchData } from "..";
import DialogSearch from "../DialogSearch";
import NumberInputWithSpinner from "./NumberInputWithSpinner";

const useStyles = makeStyles((theme) => ({
  drawer: { width: 400 },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  /* nova faixa para as tabs */
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabRoot: {
    minWidth: 0,
    paddingLeft: 8,
    paddingRight: 8,
  },
  drawerContent: {
    overflowY: 'auto',
    padding: theme.spacing(2),
    height: '100%',
  },
  drawerFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  textField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-input': { color: customtheme.black },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: customtheme.blue[500],
    },
  },
  numberField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-input': { 
      color: customtheme.black,
      textAlign: 'right',
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: customtheme.blue[500],
    },
  },
  searchIcon: {
    marginRight: theme.spacing(1),
    color: customtheme.blue[500],
  },
  backgroundColor: {
    background: customtheme.blue[500],
    color: customtheme.white,
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
  backBackgroundColor: {
    background: customtheme.gray[200],
    color: customtheme.blue[500],
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
}))

interface TabPanelProps {
  value: number;
  index: number;
  children?: React.ReactNode;
}
const TabPanel = ({ value, index, children }: TabPanelProps) => (
  <div role="tabpanel" hidden={value !== index} style={{ height: '100%' }}>
    {value === index && <Box>{children}</Box>}
  </div>
);

interface PurchaseOrderEmitItemDialogProps {
  handleClose: () => void;
  isDialogOpen: boolean;
  fieldsInit: any[];
  handleUpdateValue: (itens: any[]) => any;
  checkPrevCompanyValue: { exists: boolean, value: any };
  checkPrevBranchValue: { exists: boolean, value: any };
}

const PurchaseOrderEmitItemDialog = (props: PurchaseOrderEmitItemDialogProps) => {
  const classes = useStyles()
  const {
    isDialogOpen, fieldsInit, checkPrevCompanyValue, checkPrevBranchValue,
    handleClose, handleUpdateValue,
  } = props;
  const [tab, setTab] = useState(fieldsInit.find((field) => field.id === 'tipo')?.value?.tipo === 'servico' ? 1 : 0);

  const handleTabChange = (_: unknown, newValue: number) => {
    const update = [...fields];
    if (newValue === 1) {
      update[update.findIndex((field) => field.id === 'produto')].value = null

      update[update.findIndex((field) => field.id === 'tipo')].value = {
        tipo: 'servico'
      }
    } else {
      update[update.findIndex((field) => field.id === 'servico')].value = null
      update[update.findIndex((field) => field.id === 'tipo')].value = {
        tipo: 'produto'
      }
    }
    setFields(update)
    setTab(newValue);
  }
  const [fields, setFields] = useState<any[]>(fieldsInit);

  const [isDialogSearchOpen, setIsDialogSearchOpen] = useState(false);
  const [dialogDataSearch, setDialogDataSearch] = useState<DialogSearchData | null>(null);

  const handleAddItem = () => {
    handleUpdateValue(fields);
  }

  const handleUpdateField = (data: any) => {
    const update = [...fields];
    if(dialogDataSearch?.id === 'servicoOC') {
      update[update.findIndex((field) => field.id === 'servico')].value =
      data['codser'] === 'Nenhum item' ? null : data
    } else {
      update[update.findIndex((field) => field.id === dialogDataSearch?.id)].value =
        data[dialogDataSearch?.key || ''] === 'Nenhum item' ? null : data
    }
    
    if (dialogDataSearch?.id === 'produto') {
      if (data.unimed !== undefined && data.undefined !== null && data.undefined !== '') {
        update[update.findIndex((field) => field.id === 'unidademedida')].value = data.unimed
      }
    }
    setFields(update)
    setIsDialogSearchOpen(false);
    setDialogDataSearch(null);
  }

  const setLowerKeys = (array: Array<any>) => {
    const arrChecked = !Array.isArray(array) ? [array] : array;
    return arrChecked.map(r =>
      Object.entries(r).reduce((acc: any, [key, value]: any) => {
        acc[key.toLowerCase()] = value;
        return acc;
      }, {}),
    );
  };

  const handleCloseDialogSearch = () => {
    setIsDialogSearchOpen(false);
    setDialogDataSearch(null);
  };

  const handleOpenDialogSearch = (data: DialogSearchData) => {
    setIsDialogSearchOpen(true);
    setDialogDataSearch(data);
  };

  const handleQuantitySpinnerChange = (value: number | null) => {
    const upd = [...fields];
    upd[upd.findIndex(f => f.id === 'qtd')].value = {
      qtd: value ? value : 0.00,
    };
    setFields(upd);
  };

  const handleValueSpinnerChange = (value: number | null) => {
    const upd = [...fields];
    upd[upd.findIndex(f => f.id === 'valorunitario')].value = {
      valorunitario: value ? value : 0.00,
    };
    setFields(upd);
  };

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Adicionar item</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={tab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                className={classes.tabsBar}
              >
                <Tab label="Produto" classes={{ root: classes.tabRoot }} />
                <Tab label="Serviço" classes={{ root: classes.tabRoot }} />
              </Tabs>
              <TabPanel value={tab} index={0}>
                {/* --- Produto --- */}
                <TextField
                  label="Produto"
                  onClick={() =>
                    handleOpenDialogSearch({
                      id: 'produto',
                      title: 'Produtos',
                      keySub: 'despro',
                      key: 'codpro',
                      prevDataSearch: {},
                      hasButtonCreate: false,
                    })
                  }
                  value={handleReturnValue('produto', fields)}
                  fullWidth
                  className={classes.textField}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        className={classes.searchIcon}
                        onClick={() =>
                          handleOpenDialogSearch({
                            id: 'produto',
                            title: 'Produtos',
                            keySub: 'despro',
                            key: 'codpro',
                            prevDataSearch: {},
                            hasButtonCreate: false,
                          })
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                />

                {/* --- Derivação --- */}
                {/* <TextField
                  label="Derivação"
                  disabled={!fields.find(f => f.id === 'produto')?.value}
                  onClick={
                    fields.find(f => f.id === 'produto')?.value
                      ? () =>
                        handleOpenDialogSearch({
                          id: 'derivacao',
                          title: 'Derivação',
                          keySub: 'desder',
                          key: 'codder',
                          isPrevSearch: true,
                          prevSearch: setLowerKeys(
                            fields.find(f => f.id === 'produto')?.value?.derivacao || [],
                          ),
                          prevDataSearch: {},
                          hasButtonCreate: false,
                        })
                      : undefined
                  }
                  value={
                    fields.find(f => f.id === 'produto')?.value
                      ? handleReturnValue('derivacao', fields)
                      : 'Selecione um produto primeiro'
                  }
                  fullWidth
                  className={classes.textField}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        className={classes.searchIcon}
                        disabled={!fields.find(f => f.id === 'produto')?.value}
                        onClick={
                          fields.find(f => f.id === 'produto')?.value
                            ? () =>
                              handleOpenDialogSearch({
                                id: 'derivacao',
                                title: 'Derivação',
                                keySub: 'desder',
                                key: 'codder',
                                isPrevSearch: true,
                                prevSearch: setLowerKeys(
                                  fields.find(f => f.id === 'produto')?.value?.derivacao || [],
                                ),
                                prevDataSearch: {},
                                hasButtonCreate: false,
                              })
                            : undefined
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                /> */}
              </TabPanel>

              <TabPanel value={tab} index={1}>
                <TextField
                  label="Serviço"
                  onClick={
                    checkPrevCompanyValue.exists ?
                      checkPrevBranchValue.exists ?
                        () => handleOpenDialogSearch({
                          id: 'servicoOC',
                          title: 'Serviço',
                          keySub: 'desser',
                          key: 'codser',
                          prevDataSearch: {
                            codemp: checkPrevCompanyValue.value,
                            codfil: checkPrevBranchValue.value,
                          },
                          hasButtonCreate: false,
                        })
                        : () => { }
                      : () => { }
                  }
                  value={
                    checkPrevCompanyValue.exists ?
                      checkPrevBranchValue.exists ?
                        handleReturnValue('servico', fields)
                        : 'Selecione uma filial primeiro'
                      : 'Selecione uma empresa primeiro'
                  }
                  disabled={
                    checkPrevCompanyValue.exists ?
                      checkPrevBranchValue.exists ?
                        false
                        : true
                      : true
                  }
                  fullWidth
                  className={classes.textField}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        className={classes.searchIcon}
                        onClick={
                          checkPrevCompanyValue.exists ?
                            checkPrevBranchValue.exists ?
                              () => handleOpenDialogSearch({
                                id: 'servicoOC',
                                title: 'Serviço',
                                keySub: 'desser',
                                key: 'codser',
                                prevDataSearch: {
                                  codemp: checkPrevCompanyValue.value,
                                  codfil: checkPrevBranchValue.value,
                                },
                                hasButtonCreate: false,
                              })
                              : () => { }
                            : () => { }
                        }
                        disabled={
                          checkPrevCompanyValue.exists ?
                            checkPrevBranchValue.exists ?
                              false
                              : true
                            : true
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                />
              </TabPanel>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" style={{ gap: 32 }}>
                {/* --- Quantidade --- */}
                <NumberInputWithSpinner
                  label="Quantidade requerida"
                  value={fields.find(f => f.id === 'qtd')?.value?.qtd}
                  onChange={handleQuantitySpinnerChange}
                  step={0.01}
                  min={0.01}
                />
                <NumberInputWithSpinner
                  label="Valor"
                  value={fields.find(f => f.id === 'valorunitario')?.value?.valorunitario}
                  onChange={handleValueSpinnerChange}
                  step={0.01}
                  min={0.01}
                />
              </Box>
              <Box display="flex" style={{ gap: 32 }}>
                <TextField
                  label="Unidade de medida"
                  type="text"
                  value={fields.find(f => f.id === 'unidademedida')?.value || ''}
                  className={classes.textField}
                  onChange={e => {
                    const upd = [...fields];
                    upd[upd.findIndex(f => f.id === 'unidademedida')].value = e.target.value;
                    setFields(upd);
                  }}
                  fullWidth
                />

                {/* --- Datas --- */}
                <TextField
                  label="Data Previsão Entrega"
                  type="date"
                  value={fields.find(f => f.id === 'datprv')?.value?.datprv}
                  onChange={e => {
                    const upd = [...fields];
                    upd[upd.findIndex(f => f.id === 'datprv')].value = { datprv: e.target.value };
                    setFields(upd);
                  }}
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Centro de Custo"
                onClick={
                  checkPrevCompanyValue.exists ?
                    checkPrevBranchValue.exists ?
                      () => handleOpenDialogSearch({
                        id: 'centrosCusto',
                        title: 'Centro de Custo',
                        keySub: 'desccu',
                        key: 'codccu',
                        prevDataSearch: {
                          codemp: checkPrevCompanyValue.value,
                          codfil: checkPrevBranchValue.value,
                        },
                        hasButtonCreate: false,
                      })
                      : () => { }
                    : () => { }
                }
                value={
                  checkPrevCompanyValue.exists ?
                    checkPrevBranchValue.exists ?
                      handleReturnValue('centrosCusto', fields)
                    : 'Selecione uma filial primeiro'
                    : 'Selecione uma empresa primeiro'
                }
                fullWidth
                className={classes.textField}
                disabled={
                  checkPrevCompanyValue.exists ?
                    checkPrevBranchValue.exists ?
                      false
                    : true
                  : true
                }
                InputProps={{
                  endAdornment: (
                    <IconButton
                      className={classes.searchIcon}
                      onClick={
                        checkPrevCompanyValue.exists ?
                          checkPrevBranchValue.exists ?
                            () => handleOpenDialogSearch({
                              id: 'centrosCusto',
                              title: 'Centro de Custo',
                              keySub: 'desccu',
                              key: 'codccu',
                              prevDataSearch: {
                                codemp: checkPrevCompanyValue.value,
                                codfil: checkPrevBranchValue.value,
                              },
                              hasButtonCreate: false,
                            })
                          : () => { }
                        : () => { }
                      }
                      disabled={
                        checkPrevCompanyValue.exists ?
                          checkPrevBranchValue.exists ?
                            false
                          : true
                        : true
                      }
                    >
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
              <TextField
                label="Conta Financeira"
                onClick={() =>
                  handleOpenDialogSearch({
                    id: 'ctaFinanceira',
                    title: 'Conta Financeira',
                    keySub: 'desFinanceira',
                    key: 'codFinanceira',
                    prevDataSearch: {},
                    hasButtonCreate: false,
                  })
                }
                value={handleReturnValue('ctaFinanceira', fields)}
                fullWidth
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      className={classes.searchIcon}
                      onClick={() =>
                        handleOpenDialogSearch({
                          id: 'ctaFinanceira',
                          title: 'Conta Financeira',
                          keySub: 'desFinanceira',
                          key: 'codFinanceira',
                          prevDataSearch: {},
                          hasButtonCreate: false,
                        })
                      }
                    >
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
              <TextField
                label="Conta Contabil"
                onClick={() =>
                  handleOpenDialogSearch({
                    id: 'ctaContabil',
                    title: 'Conta Contabil',
                    keySub: 'desContabil',
                    key: 'codContabil',
                    prevDataSearch: {},
                    hasButtonCreate: false,
                  })
                }
                value={handleReturnValue('ctaContabil', fields)}
                fullWidth
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      className={classes.searchIcon}
                      onClick={() =>
                        handleOpenDialogSearch({
                          id: 'ctaContabil',
                          title: 'Conta Contabil',
                          keySub: 'desContabil',
                          key: 'codContabil',
                          prevDataSearch: {},
                          hasButtonCreate: false,
                        })
                      }
                    >
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <>
            <Button
              onClick={handleClose}
              className={classes.backBackgroundColor}
              style={{
                marginRight: 20,
              }}
            >
              Voltar
            </Button>
            <Button
              onClick={handleAddItem}
              className={classes.backgroundColor}
            >
              Confirmar
            </Button>
          </>
        </DialogActions>
      </Dialog>
      <DialogSearch
        codEmp={checkPrevCompanyValue.value}
        codFil={checkPrevBranchValue.value}
        title={dialogDataSearch?.title || ''}
        id={dialogDataSearch?.id || ''}
        keyItem={dialogDataSearch?.key || ''}
        keySubItem={dialogDataSearch?.keySub || ''}
        isDialogOpen={isDialogSearchOpen}
        isPrevSearch={dialogDataSearch?.isPrevSearch || false}
        prevSearch={dialogDataSearch?.prevSearch || []}
        prevDataSearch={dialogDataSearch?.prevDataSearch}
        handleCloseDialog={handleCloseDialogSearch}
        handleUpdateField={(data: any) => { handleUpdateField(data) }}
        hasButtonCreate={false}
      />
    </>
  )
}

export default PurchaseOrderEmitItemDialog;